import { FC, useEffect } from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { awpErrorState, awpErrorStore } from '../../modules/store/awpErrorStore';
import { StyledErrorMessage, GlobalErrorStyle } from './AwpErrorMessage.styles';
import { AwpErrorMessageProps } from './index';
import { Heading, Text, Types } from '@marriott/mi-ui-library';
import { useRouter } from 'next/router';
import clsx from 'clsx';
import { searchResultsState, useStore } from '../../modules/store/searchResultsStore';

const { NEXT_PUBLIC_AEM_SITE } = process.env;

// Use this component to conditionally render the alert message
// Setting the state.errorMessage to ' ', will hide the component
// Setting the state.errorMessage to valid value [anything apart from ''], will show the component

export const AwpErrorMessage: FC<AwpErrorMessageProps> = (props: AwpErrorMessageProps) => {
  const errorMessage = awpErrorStore((state: awpErrorState) => state.errorMessage);
  const setGenericErrorState = awpErrorStore((state: awpErrorState) => state.setGenericErrorState);
  const router = useRouter();
  let is404error = false;
  const isMapViewEnabled = useStore((state: searchResultsState) => state.isMapViewEnabled);

  if (router?.pathname === '/dining/404') {
    is404error = true;
  }

  useEffect(() => {
    const errorObj = {
      locationErrorTitle: props?.locationErrorTitle,
      locationErrorDescription: props?.locationErrorDescription,
    };
    setGenericErrorState(errorObj);
  }, [props?.locationErrorTitle, props?.locationErrorDescription, setGenericErrorState]);

  return !isMapViewEnabled ? (
    <>
      <StyledErrorMessage
        data-component-name="m-awp-AwpErrorMessage"
        data-testid="awp-AwpErrorMessage"
        isEmpty={!errorMessage}
        className={clsx(
          'container awp-error-container p-0 awp-additional-container',
          errorMessage ? 'error-message-active' : ''
        )}
      >
        <div
          className={clsx(
            'm-message-inline col-12 awp-error-message mt-3 mb-3',
            props[errorMessage as keyof typeof props] && errorMessage !== 'expandResultsError' ? 'error-sev2' : 'info'
          )}
        >
          <div className="m-message-content-wrap">
            <div className="m-message-content">
              <span>
                {props[errorMessage as keyof typeof props] ? props[errorMessage as keyof typeof props] : errorMessage}
              </span>
            </div>
          </div>
        </div>
      </StyledErrorMessage>
      {is404error && <GlobalErrorStyle />}
      <div
        data-testid="error-test"
        className={is404error ? 'error-404-container container mt-3 mt-md-5 mt-lg-5 mt-xl-5' : 'd-none'}
      >
        <Heading
          customClass="t-numbers-s pt-2 mb-0 error-heading mb-3"
          titleText={props?.errorTitle}
          variation={Types.headingType.title}
          fontSize={Types.size.small}
          element={Types.tags.h2}
        />
        <Text
          customClass="t-font-s pt-1"
          copyText={props?.errorDesc}
          fontSize={Types.size.small}
          element={Types.tags.div}
        />
      </div>
    </>
  ) : null;
};

export const AwpErrorMessageConfig = {
  emptyLabel: 'AwpErrorMessage',
  isEmpty: false,
  resourceType: `${NEXT_PUBLIC_AEM_SITE}/components/content/awperror`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const AwpErrorMessageEditable = (props: any) => (
  <EditableComponent config={AwpErrorMessageConfig} {...props}>
    <AwpErrorMessage {...props} />
  </EditableComponent>
);
